import React, {Fragment} from 'react';
import {withTranslation} from "react-i18next";
import Loading from "./Loading";
import {Modal} from 'react-bootstrap';
import EmbeddedPdf from "./EmbeddedPdf";

function SIF(props)
{

    function getSifUrl()
    {
        return '/api/process/' + props.application_token + '/sif_pdf'
            + '?term=' + props.deal.deals.term
            + '&amount=' + props.deal.deals.financed_amount
            + '&advance=' + props.deal.deals.advance_amount;
    }

    return (
        <div>
            <Modal className="modal modal--big fade p-md-5 sif"
                   dialogClassName="modal-dialog"
                   id="step_2_3b"
                   show={props.is_modal_shown}
                   onHide={props.hideSIFModal}
            >

                <div className="modal-content p-0">

                    <div className="modal-body p-0">
                        <h4 className="modal__heading p-5">STANDARTINĖ INFORMACIJA APIE VARTOJIMO KREDITĄ</h4>
                        <div className="container">
                            <p className="text-primary">{props.t('there_is_button_at_the_bottom')}</p>
                            {(props.deal === null || props.application === null) ?
                                <Loading msg={props.t('info_about_loan_is_being_prepared')}/>
                                :
                                <>
                                    <section className="mt-6 mb-4">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="row d-flex justify-content-center">
                                                        <div className="col-12 pl-0 pr-0">
                                                            <div className="embed-document">
                                                                <EmbeddedPdf src={getSifUrl(false)}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer py-2 d-flex justify-content-center">
                                                        {(props.deal !== null && props.application !== null) ?
                                                            <button className="btn btn-lg btn-primary btn-wrap"
                                                                    onClick={props.callback}
                                                            >
                                                                Supratau, noriu sudaryti sutartį
                                                            </button> : ''}
                                                    </div>
                                                    <div className="modal-footer py-2 d-flex justify-content-center">
                                                        {(props.deal !== null && props.application !== null) ?
                                                            <a href={
                                                                '/api/process/'
                                                                + props.application_token
                                                                + '/download_sif_pdf?term='
                                                                + props.deal.deals.term
                                                                + '&amount='
                                                                + props.deal.deals.financed_amount
                                                                + '&advance='
                                                                + props.deal.deals.advance_amount}
                                                               className="link-black"
                                                               target="_blank"
                                                            >
                                                                Parsisiųsti
                                                            </a> : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );

}

export default withTranslation()(SIF);
